export default {
    provider: {
        // Loads pending invites
        pendingInvites: {
            type: "get",
            error: {
                default: "Unable to load your sent invites.",
            },
        },

        // Gets provider name and contact information
        getData: {
            type: "get",
            error: {
                default: "Unable to load provider information.",
            },
        },
        /*Params:
        * - #providerID?: The provider ID to get data for
        *   - Defaults to logged in provider
        */

        // Retrieves list of patients under logged in provider
        patients: {
            type: "get",
            error: {
                default: "Unable to load patients.",
            },
        },
        allPatients: {
            type: "get",
            error: {
                default: "Unable to load all patients.",
            },
        },
        clinicians: {
            type: "get",
            error: {
                default: "Unable to load clinicians.",
            },
        },
        // Retrieves list of all patients under logged in provider for admin
        patientsall: {
            type: "get",
            error: {
                default: "Unable to load all patients.",
            },
        },
        // Retrieves list of practices
        practices: {
            type: "get",
            error: {
                default: "Unable to load practices.",
            },
        },

        // Get practice
        getPractice: {
            type: "get",
            error: {
                default: "Unable to load practice.",
            },
        },
        /*Params:
        * - #practiceID: The practice ID to get data for
        */

        // Gets provider's account data
        getClinicianAccount: {
            type: "get",
            error: {
                default: "Unable to load your account information.",
            },
        },

        // Saves provider's account data
        saveClinicianAccount: {
            type: "patch",
            error: {
                default: "Unable to save your account information.",
            },
        },
        sendMessage: {
            type: "put",
            success: {
                default: "Successfully send message.",
            },
            error: {
                default: "Failed to send message.",
            },
        },
        getMessages: {
            type: "get",
            error: {
                default: "Failed to get messages.",
            },
        },
        updateMessage: {
            type: "put",
            error: {
                default: "Failed to update message.",
            },
        },
        deleteMessage: {
            type: "put",
            error: {
                default: "Failed to delete message.",
            },
        },
        getNewMessages: {
            type: "get",
            error: {
                default: "Failed to get new messages.",
            },
        },
        sendDocMessage: {
            type: "put",
            error: {
                default: "Failed to send message.",
            },
        },
        consents: {
            type: "get",
            error: {
                default: "Unable to load consents.",
            },
        },
        saveConsent: {
            type: "patch",
            error: {
                default: "Failed to save consent.",
            },
        },
        getConsent: {
            type: "get",
            error: {
                default: "Unable to load consent.",
            },
        },
        deleteConsent: {
            type: "put",
            error: {
                default: "Failed to delete consent.",
            },
        },
        CPTList: {
            type: "get",
            error: {
                default: "Failed to get CPT list.",
            },
        },
        InsuranceList: {
            type: "get",
            error: {
                default: "Failed to get insurance list.",
            },
        },
        InsuranceById: {
            type: "get",
            error: {
                default: "Failed to get insurance.",
            },
        },
        delInsurance: {
            type: "put",
            error: {
                default: "Failed to delete insurance.",
            },
        },
        DelCPT: {
            type: "put",
            error: {
                default: "Failed to delete CPT.",
            },
        },
        SaveCPT: {
            type: "patch",
            error: {
                default: "Failed to save CPT.",
            },
        },
        saveInsurance: {
            type: "patch",
            error: {
                default: "Failed to save insurance.",
            },
        },
        getClinicianById: {
            type: "get",
            error: {
                default: "Unable to load clinician information.",
            },
        },
        saveClinicianById: {
            type: "patch",
            error: {
                default: "Unable to save clinician information.",
            },
        },
        getConsentPatientsById: {
            type: "get",
            error: {
                default: "Unable to load ConsentPatients information.",
            },
        },
        saveConsentPatients: {
            type: "patch",
            error: {
                default: "Unable to save ConsentPatients information.",
            },
        },
        getActivePatients: {
            type: "get",
            error: {
                default: "Unable to load ActivePatients information.",
            },
        },
        deleteInvite: {
            type: "put",
            error: {
                default: "Failed to delete invitation.",
            },
        },
    },

};
